var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState } from "react";
export var StepperControlContext = createContext({});
var ALL_STEPS = ["0", "1", "2"];
export var StepperControlProvider = function (_a) {
    var children = _a.children;
    // NOTE: Query Params para testes, não apagar
    // const { search } = useLocation();
    // const searchParams = new URLSearchParams(search);
    // const currentStep = searchParams.get('step');
    var _b = useState(), serviceReturn = _b[0], setServiceReturn = _b[1];
    var _c = useState(true), disableButtonAdvance = _c[0], setDisableButtonAdvance = _c[1];
    //   const [activeStep, setactiveStep] = useStorage(localStorageCurrentActiveStep);
    var _d = useState(0), activeStep = _d[0], setactiveStep = _d[1];
    // NOTE: Query Params para testes, não apagar
    // useEffect(() => {
    //   if (currentStep && ALL_STEPS.includes(currentStep)) {
    //     setactiveStep(Number(currentStep));
    //   }
    // }, [currentStep]);
    var handlePrevStep = function () {
        var newActiveStep = activeStep - 1;
        setactiveStep(newActiveStep);
    };
    var handleNextStep = function () {
        var newActiveStep = activeStep + 1;
        setactiveStep(newActiveStep);
    };
    var moveThroughStep = function (step) {
        setactiveStep(step);
    };
    return (_jsx(StepperControlContext.Provider, __assign({ value: {
            serviceReturn: serviceReturn,
            setServiceReturn: setServiceReturn,
            activeStep: activeStep,
            disableButtonAdvance: disableButtonAdvance,
            setactiveStep: setactiveStep,
            setDisableButtonAdvance: setDisableButtonAdvance,
            handlePrevStep: handlePrevStep,
            handleNextStep: handleNextStep,
            moveThroughStep: moveThroughStep,
        } }, { children: children })));
};
